<div class="fd-accreditation-login" [fxFlex.md]="50" [fxFlex.lg]="75">
  <div class="fd-accreditation-login__title">
    <h4>CREDENCIAMENTO - ADMIN</h4>
    <img class="fd-accreditation-login__fiserv-logo" src="assets/img/fiserv-logo.png">
  </div>

  <form [formGroup]="formGroup" (keyup.enter)="login()">
    <div fxLayout="column" fxLayoutAlign="center stretch">
      <div>
        <fd-input [parentForm]="formGroup" [field]="fields.user"></fd-input>
      </div>
      <div>
        <fd-input [parentForm]="formGroup" [field]="fields.password"></fd-input>
        <a class="right-text" (click)="goToPasswordRecovery()">Esqueci minha senha</a>
      </div>
    </div>
    <br>

    <p class="otp-option-title" *ngIf="isMFA && !isOptOptionDisabled">Como você deseja receber o token: </p>
    
    <mat-radio-group aria-label="Selecione uma opção" formControlName="tokenChannel" (change)="isRadioSelected($event)" *ngIf="isMFA && !isOptOptionDisabled">
      <div class="fd-radio-button__option-container">
        <mat-radio-button value="EMAIL" >{{userEmail | coverEmailPhone:'email'}}</mat-radio-button>
      </div>
      <div *ngIf="userPhone" class="fd-radio-button__option-container"> 
        <mat-radio-button value="SMS">{{userPhone | coverEmailPhone:'phone'}}</mat-radio-button>
      </div>      
    </mat-radio-group>


    <div class="mfa-token" *ngIf="isMFA && isOptOptionDisabled && radioValue"> <!--*ngIf="radioValue"-->
      <fd-input (pasteHandler)="handlerMFAPaste($event)" [parentForm]="formGroup" [field]="fields.mfaToken"></fd-input>     
      <a *ngIf="isOptOptionDisabled && userPhone" class="left-text" (click)="enableOtpOption()">Mudar Opção</a> 
      <a class="right-text" (click)="reenviarToken()">Reenviar Token</a>
    </div>
    
  </form>

  <div class="login-button">
    <fd-button fdFatButton mat-flat-button [disabled]="isLoginDisabled()" [content]="'Entrar'" (trigger)="login()">
    </fd-button>
  </div>
</div>
